module.exports = __webpack_public_path__ + "static/media/create.c53e8721.svg";